/* Add any specific styles for chip-list-section here if needed */
